export default "__VITE_ASSET__41aad6af__"